import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import auth, { featureEnabled, getString, installUpdate, messageDialog, startpoll } from "../../js/auth";
import { I18n } from "react-redux-i18n";
import "leaflet-draw/dist/leaflet.draw.css";
import admin from "../../js/admin";
import moment from "moment";
import CanAccess from "../CanAccess";
import { hasAccess } from "../../js/authProvider";
import { update } from "lodash";
import UpdateAvailable from "../icon-buttons/UpdateAvailable";
import TopBar from "../TopBar";
import { openChatGpt } from "../icon-buttons/ChatGptButton";
import { getGuidelinesLastSeen, hasUnseenGuidelines } from "../../admin/guidelinesSeen";
import { isSuperAdminStatus } from "../../admin/VideoGuides";

const DEFAULT_GUIDELINE_ENTRIES = require("../../admin/guidelinesEntries");

class MainMenu extends AbstractMenu {
  state = {
    rocketToken: null
  };

  translateWithFallback = (key, fallback) => {
    const translated = I18n.t(key);
    return translated === key ? fallback : translated;
  };

  hasNewGuidelines = () => {
    const raw = this.props.myStatus?.restaurant_settings?.["guidelines-whats-new"];
    const fromSettings = Array.isArray(raw) ? raw : raw?.entries;
    const entries = Array.isArray(fromSettings) ? fromSettings : DEFAULT_GUIDELINE_ENTRIES;
    return hasUnseenGuidelines(entries, getGuidelinesLastSeen(this.props.myStatus?.id), this.props.myStatus, this.props.rbac);
  };

  componentDidMount = () => {
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
    /*
    if (this.state.rocketToken === null && auth.myStatus?.id) {
      this.setState({ rocketToken: "init" });
      getString("rocket/login").done(token => {
        this.setState({ rocketToken: token });
      }).fail(() => {
        this.setState({ rocketToken: "error" });
        auth.ajaxError = false;
      });
    }*/
  };

  ntakCheck = () => {
    if (!featureEnabled("ntak"))
      return;
    const { local, admin_local, myStatus, features } = this.props;
    if (this.props.myStatus.roles && !this.state.warningShown) {
      const ntakConnectionOK = this.props.myStatus?.ntakstatus?.status?.connectionOK;
      this.setState({ warningShown: true });
      admin.getActiveMenuItems(data => {
        function checkNtak(category) {
          if (category.activeMenuItems.find(m => m.isTop && (!m.defaultMainCategoryId || !m.defaultSubCategoryId))) return true;
          if (category.activeMenuCategories.filter(m => m.isActive && m.isTop).find(checkNtak)) return true;
        }
        const drinkproblem = data.activeMenuCategories.filter(m => m.isActive && m.isTop && m.entityType === "DrinkCategory").find(checkNtak);
        const mealproblem = data.activeMenuCategories.filter(m => m.isActive && m.isTop && m.entityType === "MealCategory").find(checkNtak);
        this.setState({ ntakProblem: !ntakConnectionOK, mealNtakProblem: mealproblem, drinkNtakProblem: drinkproblem });
        if (!ntakConnectionOK || mealproblem || drinkproblem)
          if (!this.props.myStatus.test_mode)
            messageDialog(local.warning_message, local.please_perform_ntak_registration);
      })
    }
  }
  componentDidUpdate = () => {
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
    this.ntakCheck();
    /*
    if (this.state.rocketToken === null && auth.myStatus?.id) {
      this.setState({ rocketToken: "init" });
      getString("rocket/login").done(token => {
        this.setState({ rocketToken: token });
      }).fail(() => {
        this.setState({ rocketToken: "error" });
        auth.ajaxError = false;
      });
    }*/
  };

  render() {

    const { admin_local, myStatus, updateAvailable } = this.props;


    const background = "#847556";
    const superAdminBackground = "red";
    if (admin_local && myStatus.roles) {
      const appAccess = auth.device.platform === "browser" || hasAccess("superAdminMenus") ? true : this.props.myStatus.restaurant_settings["enabled-features"].appAccess ? this.props.myStatus.restaurant_settings["enabled-features"].appAccess.enabled : false;
      const ntakProblem = this.state.ntakProblem || this.state.drinkNtakProblem || this.state.mealNtakProblem;
      return (
        <React.Fragment>
          <div className="mainMenuWrap">
            <TopBar {...this.props} />
            <div className="mainMenuGrid">
            {(this.props.activeRestaurant && this.props.activeRestaurant !== 0) ? (
              <React.Fragment>
                <CanAccess resource="superAdminMenus/">
                    <MenuButton myStatus={myStatus} roles={["superadmin"]} id="restaurants" href={"superAdminMenus"} background={superAdminBackground} backgroundImage={require("../../img/menu-new/settings.svg")} name={admin_local.menus.superAdminMenu} />
                </CanAccess>
                {appAccess && (
                  <>
                      {updateAvailable && (<MenuButton
                      myStatus={myStatus}
                      onClick={installUpdate}
                      id="update"
                      data-step="1"
                      data-intro=""
                      error={true}
                      backgroundImage={require("../../img/update.svg")}
                      name={I18n.t("local.installing_update")}
                    ></MenuButton>)}
                    <CanAccess resource="sales.tablesoverview.view">
                      <MenuButton
                        myStatus={myStatus}
                        href="/tablesOverview"
                        id="table-overview"
                        data-step="3"
                        data-intro=""
                        background={background}
                          backgroundImage={require("../../img/menu-new/table-overview-map.svg")}
                        name={admin_local.menus.tableOverview}
                      />
                    </CanAccess>
                    <CanAccess resource="sales.pointofsale.view">
                      {this.props.pointOfSales.length > 0 ?
                        <MenuButton
                          myStatus={myStatus}
                          id="restaurants"
                          href={"pointOfSales"}
                          background={background}
                            backgroundImage={require("../../img/menu-new/monitor.svg")}
                          name={admin_local.menus.pointOfSales}
                        /> : null}
                    </CanAccess>
                    <CanAccess resource="kiosk">
                      {this.props.kiosks.length > 0 ?
                        <MenuButton
                          myStatus={myStatus}
                          id="restaurants"
                          href={"kiosks"}
                          background={background}
                            backgroundImage={require("../../img/menu-new/kiosk-self-order.svg")}
                          name={admin_local.menus.kiosks}
                        /> : null}
                    </CanAccess>
                    <CanAccess resource="ntak">
                      {(featureEnabled('ntak') || featureEnabled('fiskaly_de')) && moment(auth.myStatus.restaurant_settings["enabled-features"]?.ntak?.startdate).isBefore(moment()) ?
                        <MenuButton
                          href="/opening_hours"
                          myStatus={this.props.myStatus}
                          background={background}
                            backgroundImage={require("../../img/menu-new/calendar.svg")}
                          name={I18n.t("admin_local.menus.opening_hours")} /> : null}
                    </CanAccess>
                    <CanAccess resource="tablebooking">
                      <MenuButton
                        myStatus={myStatus}
                        href="/tableReservations"
                        background={background}
                          backgroundImage={require("../../img/menu-new/clock.svg")}
                        name={admin_local.menus.tableBooking}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="courierapp">
                      {(featureEnabled("homedelivery") && auth.device.platform !== "abrowser") ?
                        <MenuButton
                          myStatus={myStatus}
                          features={["homedelivery.courierapp"]}
                          id="restaurants"
                          href={"courierApp"}
                          background={background}
                            backgroundImage={require("../../img/menu-new/truck.svg")}
                          name={admin_local.courier}
                        /> : null}
                    </CanAccess>
                    <CanAccess resource="bar">
                      <MenuButton
                        myStatus={myStatus}
                        href="/drinkbar"
                        id="drinkbar"
                        background={background}
                          backgroundImage={require("../../img/menu-new/coffee.svg")}
                        name={admin_local.menus.bar}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="serving">
                      <MenuButton
                        myStatus={myStatus}
                        href="/kitchen"
                        id="drinkbar"
                        background={background}
                          backgroundImage={require("../../img/menu-new/kitchen-serving.svg")}
                        name={admin_local.menus.serving}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="waiter">
                      <MenuButton
                        myStatus={myStatus}
                        href="/waiterScreen"
                        id="waiterScreen"
                        background={background}
                          backgroundImage={require("../../img/menu-new/users.svg")}
                        name={admin_local.menus.waiterScreen}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="guestscreen">
                      <MenuButton
                        myStatus={myStatus}
                        href="/guestScreen"
                        id="guestScreen"
                        background={background}
                          backgroundImage={require("../../img/menu-new/guest-ready-screen.svg")}
                        name={admin_local.menus.guestScreen}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="kitchen">
                      <MenuButton
                        myStatus={myStatus}
                        href={"/productionLinesMenu"}
                        background={background}
                          backgroundImage={require("../../img/menu-new/kitchen.svg")}
                        name={admin_local.menus.productionLines}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="reports">
                      <MenuButton
                        myStatus={myStatus}
                        href={"/reportsMenu"}
                        background={background}
                          backgroundImage={require("../../img/menu-new/bar-chart-2.svg")}
                        name={admin_local.menus.reports}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="stockmanagement">
                      <MenuButton
                        myStatus={myStatus}
                        features={["inventory"]}
                        href={"/stockManagementMenu"}
                        background={background}
                          backgroundImage={require("../../img/menu-new/package.svg")}
                        name={admin_local.menus.stockManagement}
                      ></MenuButton>
                    </CanAccess>
                    <CanAccess resource="administration">
                      <MenuButton
                        myStatus={myStatus}
                        href={"adminMenu"}
                        background={background}
                          backgroundImage={require("../../img/menu-new/tool.svg")}
                        error={ntakProblem}
                        name={admin_local.menus.administration}>
                        {!ntakProblem ? null : <i className="icon-attention" style={{ color: "yellow", animation: "opacity 3s infinite steps(10)" }} >ntak</i>}
                      </MenuButton>
                    </CanAccess>
                    <CanAccess resource="newsletter">
                      <MenuButton
                        features={["mautic"]}
                        href={"https://" + localStorage.instance + ".mautic.eatwithme.online"}
                        external={true}
                        background={background}
                          backgroundImage={require("../../img/menu-new/message-circle.svg")}
                        name={admin_local.menus.mautic} myStatus={this.props.myStatus}></MenuButton>
                    </CanAccess>

                      <MenuButton
                        myStatus={myStatus}
                        href={"/guidelines"}
                        badge={this.hasNewGuidelines()}
                        background={background}
                        backgroundImage={require("../../img/menu-new/activity.svg")}
                        name={this.translateWithFallback("admin_local.menus.guidelines_whats_new", "Guidelines & What's new")}
                      />

                      {isSuperAdminStatus(myStatus) && (
                        <MenuButton
                          myStatus={myStatus}
                          href={"/videoGuides"}
                          background={superAdminBackground}
                          backgroundImage={require("../../img/menu-new/activity.svg")}
                          name={this.translateWithFallback("admin_local.menus.video_guides", "Video guide")}
                        />
                      )}
                  </>)}

                <MenuButton
                  myStatus={myStatus}
                  onClick={openChatGpt}
                  id="chatgpt"
                  background={background}
                  backgroundImage={require("../../img/menu-new/chatgpt.svg")}
                  name={I18n.t("admin_local.menus.chatgpt", { defaultValue: "ChatGPT" })} />

                <MenuButton
                  href={"/chat"}
                  background={background}
                    backgroundImage={require("../../img/menu-new/help-circle.svg")}
                  name={admin_local.menus.chat_with_support} myStatus={this.props.myStatus}></MenuButton>

              </React.Fragment>
            ) : (null)
            }
            </div>
            <div id="updateLabel"></div>
          </div>
        </React.Fragment >
      );
    } else return null;
  }
}

const mapStateToProps = state => {
  return {
    features: state.rootReducer.myStatus.restaurant_settings ? state.rootReducer.myStatus.restaurant_settings["enabled-features"] : undefined,
    admin_local: state.rootReducer.admin_local,
    local: state.rootReducer.local,
    myStatus: state.rootReducer.myStatus,
    rbac: state.rootReducer.rbac,
    activeRestaurant: state.rootReducer.activeRestaurant,
    pointOfSales: state.rootReducer.pointOfSales ? state.rootReducer.pointOfSales : [],
    kiosks: state.rootReducer.kiosks ? state.rootReducer.kiosks : [],
    updateAvailable: state.rootReducer.updateAvailable
  };
};

export default connect(mapStateToProps)(withRouter(MainMenu));
